import { useEffect, useState, useMemo } from "react";
import ApiServices from "../../config/ApiServices";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { hideLoader, showLoader } from "../../redux/actions/LoaderActions";
import Loader from "../../utils/Loader";
import ModalManager from "../../Modals/ModalManager";
import { useParams } from "react-router-dom";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import IconButton from '@mui/material/IconButton';
import { Link } from "react-router-dom";
import Pagination from "../../utils/Pagination";
import { showModal } from "../../redux/actions/ModalActions";

export default function ManageMarks({ title }) {
    const dispatch = useDispatch();
    const loading = useSelector((state) => state.loader.loading);
    const isOpen = useSelector((state) => state.modal.isOpen);
    const { batchId, testId } = useParams();
    const [marks, setMarks] = useState([]);
    const [students, setStudents] = useState([]);
    const [newMarks, setNewMarks] = useState({});
    const [errors, setErrors] = useState({});
    const [hasInvalidMarks, setHasInvalidMarks] = useState(false);
    const [isDataChanged, setIsDataChanged] = useState(false);
    const [maxMarks, setMaxMarks] = useState(0);
    const [DueDate, setDueDate] = useState(false);
    const [currentPage, setCurrentPage] = useState(0);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [totalData, setTotalData] = useState(0);
    const [submittedAttachments, setSubmittedAttachments] = useState([]); 

    useEffect(() => {
        if (!isOpen) {
            getMarks();
            getAllStudents();
            getTest();
            getSubmittedAttachments(); 
        }
    }, [isOpen]);

    const userRole = sessionStorage.getItem("userRole");

    const getAllStudents = () => {
        dispatch(showLoader());
        ApiServices.apiRequest("getAssignStudentPagination", { batchId, status: true, limit: itemsPerPage, pageno: currentPage + 1 })
            .then((res) => {
                if (res.data.success) {
                    const activeStudents = res.data.data[0]?.students?.filter(
                        (student) => student.studentstatus === true
                    ) || [];
                    setStudents(activeStudents);
                    setTotalData(res.data.totaldocuments ? res.data.totaldocuments : 0);
                    console.log("students pagination data:", res.data.data);
                } else {
                    toast.error(res.data.message);
                }
            })
            .catch((err) => {
                toast.error(err?.message || "Something went wrong");
            })
            .finally(() => {
                dispatch(hideLoader());
            });
    };

    const getMarks = () => {
        dispatch(showLoader());
        ApiServices.apiRequest("getMarks", { testId: testId })
            .then((res) => {
                if (res.data.success) {
                    setMarks(res.data.data);
                    console.log("marks data is:", res.data.data)
                } else {
                    toast.error(res.data.message);
                }
            })
            .catch((err) => {
                toast.error(err?.message || "Something went wrong");
            })
            .finally(() => {
                dispatch(hideLoader());
            });
    };

    const getTest = () => {
        dispatch(showLoader());
        ApiServices.apiRequest("getSingleTask", { _id: testId })
            .then((res) => {
                if (res.data.success) {
                    // console.log("hlo",res.data.data.date);

                    let isMiss= new Date(res.data.data.date) > new Date().setHours(0,0,0,0)
                    console.log(isMiss);
                    
                    
                    setDueDate(isMiss)

                   ;
                    
                    setMaxMarks(res.data.data.maximumMarks);
                } else {
                    toast.error(res.data.message);
                }
            })
            .catch((err) => {
                toast.error(err?.message || "Something went wrong");
            })
            .finally(() => {
                dispatch(hideLoader());
            });
    };

    const getSubmittedAttachments = () => {
        ApiServices.apiRequest("getUploadedTask", { taskId: testId })
            .then((res) => {
                if (res.data.success) {
                    setSubmittedAttachments(res.data.data); // expected: [{ studentId, attachments }]
                }
            })
            .catch((err) => {
                toast.error(err?.message || "Something went wrong");
            });
    };

    const hasStudentSubmitted = (studentId) => {
        return submittedAttachments.some(
            (item) =>
                (item.studentId?._id === studentId || item.studentId === studentId) &&
                item.attachments?.length > 0
        );
    };

    const getStudentMarks = (studentId) => {
        const studentMark = marks.find(mark => mark.studentId?._id === studentId);
        return studentMark ? studentMark.score : null;
    };

    const handleMarksChange = (studentId, value) => {
        if (/^\d*$/.test(value)) {
            setNewMarks({ ...newMarks, [studentId]: value });
            setErrors({ ...errors, [studentId]: null });
        }
    };

    const handleMarksChangeUpdate = (studentId, value) => {
        if (/^\d*$/.test(value)) {
            setNewMarks(prevState => ({ ...prevState, [studentId]: value }));
            setErrors(prevState => ({ ...prevState, [studentId]: null }));
        }
    };

    const handleBlur = (studentId) => {
        const value = newMarks[studentId];
        if (value === "" || value < 0 || value > maxMarks) {
            setErrors({ ...errors, [studentId]: `Please enter a number between 0 and ${maxMarks}` });
            setHasInvalidMarks(true);
        } else {
            setErrors({ ...errors, [studentId]: null });
            setHasInvalidMarks(Object.values(newMarks).some(mark => mark === "" || mark < 0 || mark > maxMarks));
        }
    };

    const getStudentMarksId = (studentId) => {
        const studentMark = marks.find(mark => mark.studentId?._id === studentId);
        return studentMark ? studentMark._id : null;
    };

    const handleBlurUpdate = (studentId) => {
        const value = newMarks[studentId];
        const marksId = getStudentMarksId(studentId);
        if (value === "" || value < 0 || value > maxMarks) {
            setErrors({ ...errors, [studentId]: `Please enter a number between 0 and ${maxMarks}` });
            setHasInvalidMarks(true);
        } else {
            setErrors({ ...errors, [studentId]: null });
            setHasInvalidMarks(Object.values(newMarks).some(mark => mark === "" || mark < 0 || mark > maxMarks));
            let data = {
                _id: marksId,
                score: value
            };
            dispatch(showModal("StatusModal", data, "updateMarks", "updateMarks"));
        }
    };

    const handleBulkAssignMarks = () => {
        const updatedMarks = Object.keys(newMarks).map(studentId => ({
            studentId,
            testId,
            score: newMarks[studentId]
        }));
        if (updatedMarks.length === 0) {
            toast.info("No new marks assigned.");
            return;
        }
        ApiServices.apiRequest("bulkAssignMarks", { marks: JSON.stringify(updatedMarks) })
            .then((res) => {
                if (res.data.success) {
                    toast.success("Marks assigned successfully");
                    // instead of manually adding dummy marks, refresh from backend so we get _id
                    getMarks();
                } else {
                    toast.error(res.data.message);
                }
            })
            .catch((err) => {
                toast.error(err?.message || "Something went wrong");
            });
    };

    const handleUpdateMarks = (studentId, score) => {
        const marksId = getStudentMarksId(studentId);
        let data = {
            _id: marksId,
            score: score
        };
        console.log("id data:", data)
        dispatch(showModal("StatusModal", data, "updateMarks", "updateMarks"));
    };

    const handleAssignMarks = (studentId, score) => {
        let data = {
            studentId: studentId,
            score: score,
            testId: testId
        };
        ApiServices.apiRequest("assignMarks", data)
            .then((res) => {
                if (res.data.success) {
                    toast.success("Marks assigned successfully");
                    getMarks();
                } else {
                    toast.error(res.data.message);
                }
            })
            .catch((err) => {
                toast.error(err?.message || "Something went wrong");
            });
    };

    const handlePageChange = (event, newPage) => {
        setCurrentPage(newPage);
    };

    const handleItemsPerPageChange = (event) => {
        setItemsPerPage(parseInt(event.target.value, 10));
        setCurrentPage(0);
    };

    const getHistory = (studentId) => {
        const history = marks.find(mark => mark.studentId?._id === studentId);
        dispatch(showModal("MarksHistory", history));
    };

   
    const hasUnmarkedStudents = useMemo(() => {
        return students?.some(student => getStudentMarks(student.studentId?._id) === null);
    }, [students, marks]);

    return (
        <>
            <div className="container">
                <div className="page-inner">
                    {loading && !isOpen ? (
                        <Loader />
                    ) : (
                        <>
                            <div className="d-flex justify-content-between align-items-left align-items-md-center flex-column flex-md-row pt-2 pb-4">
                                <div>
                                    <h3 className="fw-bold mb-3">{title}</h3>
                                </div>
                                {userRole == 2 && hasUnmarkedStudents && (
                                    <div className="d-flex justify-content-end">
                                        <button className="btn btn-primary" onClick={handleBulkAssignMarks} disabled={hasInvalidMarks}>
                                            Bulk Assign Marks
                                        </button>
                                    </div>
                                )}
                            </div>
                            <div className="container">
                                <div className="row">
                                    {students?.length > 0 ? (
                                        students.map((student, index) => (
                                            <div className="col-sm-12 text-capitalize" key={index}>
                                                <div className="d-flex justify-content-between align-items-center ">
                                                    <div className="w-50">
                                                        <div className="fs-5">{student.studentId?.name}</div>
                                                        <span>{student.studentId?.email}</span>
                                                    </div>
                                                    <div>
                                                        {getStudentMarks(student.studentId?._id) !== null ? (
                                                            userRole == 2 ? (
                                                                <>
                                                                    <div className="d-flex align-items-center justify-content-end">
                                                                        <div>
                                                                            <input
                                                                                type="text"
                                                                                className="form-control d-inline-block ms-2 rounded-0 text-center"
                                                                                style={{ width: "40px", height: "20px", padding: "0px", border: "none", borderBottom: "1px solid #ccc", background: "transparent" }}
                                                                                value={newMarks[student.studentId?._id] !== undefined ? newMarks[student.studentId?._id] : (getStudentMarks(student.studentId?._id) || "")}
                                                                                onChange={(e) => handleMarksChangeUpdate(student.studentId?._id, e.target.value)}
                                                                                onBlur={() => handleBlurUpdate(student.studentId?._id)}
                                                                            />/{maxMarks}
                                                                        </div>
                                                                        <div className="dropdown ms-3">
                                                                            <IconButton type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                                                <MoreVertIcon />
                                                                            </IconButton>
                                                                            <ul className="dropdown-menu">
                                                                                <li>
                                                                                    <a className="dropdown-item" href="#" onClick={() => {
                                                                                        handleUpdateMarks(student?.studentId?._id, newMarks[student.studentId?._id]);
                                                                                    }} style={{ pointerEvents: hasInvalidMarks ? 'none' : 'auto', color: hasInvalidMarks ? 'gray' : 'black' }}>
                                                                                        Update
                                                                                    </a>
                                                                                    <a className="dropdown-item" href="#" onClick={() => { getHistory(student?.studentId?._id) }}>
                                                                                        History
                                                                                    </a>
                                                                                    <Link className="dropdown-item" to={`/trainer/taskdetails/${testId}/${student?.studentId?._id}`} style={{ pointerEvents: hasInvalidMarks ? 'none' : 'auto', color: hasInvalidMarks ? 'gray' : 'black' }}>
                                                                                        View
                                                                                    </Link>
                                                                                </li>
                                                                            </ul>
                                                                        </div>
                                                                    </div>
                                                                    {errors[student.studentId?._id] && (
                                                                        <div className="text-danger ms-2" style={{ fontSize: "12px" }}>{errors[student.studentId?._id]}</div>
                                                                    )}
                                                                </>
                                                            ) : (
                                                                `${getStudentMarks(student.studentId?._id)}/${maxMarks}`
                                                            )
                                                        ) : (
                                                            <>
                                                                <div className="d-flex align-items-center justify-content-end">
                                                                    <div className="d-flex align-items-center">
                                                                        <div>
                                                                            {hasStudentSubmitted(student.studentId?._id) ? (
                                                                                <span className="text-success">Submitted</span>
                                                                            ) : (
                                                                                
                                                                                
                                                                                <div className={DueDate? "text-warning d-inline-block":"text-danger d-inline-block" }>{DueDate? "Pending":"Missing" }</div>
                                                                            )}
                                                                            {userRole == 2 &&
                                                                                <span>
                                                                                    <input
                                                                                        type="text"
                                                                                        className="form-control d-inline-block ms-2 rounded-0 text-center"
                                                                                        style={{ width: "40px", height: "20px", padding: "0px", border: "none", borderBottom: "1px solid #ccc", background: "transparent" }}
                                                                                        value={newMarks[student.studentId?._id] !== undefined ? newMarks[student.studentId?._id] : (getStudentMarks(student.studentId?._id) !== null ? getStudentMarks(student.studentId?._id) : "")}
                                                                                        onChange={(e) => handleMarksChange(student.studentId?._id, e.target.value)}
                                                                                        onBlur={() => handleBlur(student.studentId?._id)}
                                                                                    />/{maxMarks}
                                                                                </span>
                                                                            }
                                                                        </div>
                                                                        {userRole == 2 && (
                                                                            <div className="dropdown ms-3">
                                                                                <IconButton type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                                                    <MoreVertIcon />
                                                                                </IconButton>
                                                                                <ul className="dropdown-menu">
                                                                                    <li>
                                                                                        <a className="dropdown-item" href="#" onClick={() => {
                                                                                            handleAssignMarks(student?.studentId?._id, newMarks[student.studentId?._id]);
                                                                                        }} style={{ pointerEvents: hasInvalidMarks ? 'none' : 'auto', color: hasInvalidMarks ? 'gray' : 'black' }}>
                                                                                            Assign
                                                                                        </a>
                                                                                    </li>
                                                                                    <li>
                                                                                        <Link className="dropdown-item" to={`/trainer/taskdetails/${testId}/${student?.studentId?._id}`} style={{ pointerEvents: hasInvalidMarks ? 'none' : 'auto', color: hasInvalidMarks ? 'gray' : 'black' }}>
                                                                                            View
                                                                                        </Link>
                                                                                    </li>
                                                                                </ul>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                                {errors[student.studentId?._id] && (
                                                                    <div className="text-danger ms-2" style={{ fontSize: "12px" }}>{errors[student.studentId?._id]}</div>
                                                                )}
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                                <hr className="my-1" />
                                            </div>
                                        ))
                                    ) : (
                                        <h1>No Student Present!!</h1>
                                    )}
                                </div>
                                <div className="d-flex justify-content-end">
                                    <Pagination
                                        count={totalData}
                                        page={currentPage}
                                        itemsPerPage={itemsPerPage}
                                        onPageChange={handlePageChange}
                                        onItemsPerPageChange={handleItemsPerPageChange}
                                    />
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </>
    );
}
